export enum ProgramEnroledEventType {
  AUTOENROLEDEVENT = 'AutoenroledEvent'
}

export interface ProgramEnroledEvent {
  type: ProgramEnroledEventType.AUTOENROLEDEVENT
}
